import { motion } from "framer-motion";

const steps = [
  {
    num: "I",
    title: "Kapcsolatfelvétel",
    text: "Hívjon vagy írjon üzenetet, és egyeztetjük az Önnek megfelelő időpontot.",
    detail: "Telefon · SMS · E-mail",
  },
  {
    num: "II",
    title: "Rövid egyeztetés",
    text: "Átbeszéljük, milyen típusú kezelésre van szüksége, és mire érdemes figyelni.",
    detail: "Személyre szabott tanácsadás",
  },
  {
    num: "III",
    title: "Kezelés nyugodt környezetben",
    text: "A megbeszélt időpontban zavartalan, figyelmes és személyre szabott kezelés várja.",
    detail: "Diszkrét, prémium környezet",
  },
];

const HowItWorks = () => {
  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="relative py-28 md:py-40 lg:py-48 bg-anthracite-900 overflow-hidden"
    >
      <div className="absolute top-20 left-0 font-serif text-[18rem] md:text-[26rem] text-white/[0.025] leading-none pointer-events-none select-none">
        04
      </div>

      <div className="max-w-[1500px] mx-auto px-6 md:px-10 lg:px-14 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="grid grid-cols-12 gap-8 items-end mb-20 md:mb-24"
        >
          <div className="col-span-12 md:col-span-7">
            <div className="flex items-center gap-4 mb-6">
              <span className="text-[10px] uppercase tracking-[0.4em] text-gold-500/80">
                04 — Folyamat
              </span>
              <div className="w-16 h-px bg-gold-500/40" />
            </div>
            <h2
              data-testid="how-title"
              className="font-serif text-cream leading-[1.02] tracking-[-0.02em] font-light"
            >
              <span className="block text-4xl md:text-5xl lg:text-6xl">Három egyszerű</span>
              <span className="block text-4xl md:text-5xl lg:text-6xl italic gold-gradient-text mt-2">
                lépésben.
              </span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4 md:col-start-9">
            <p className="text-cream/55 font-light text-sm md:text-base leading-relaxed border-l border-gold-500/30 pl-6">
              Az első hívástól az utolsó simításig — sietség és bizonytalanság nélkül.
            </p>
          </div>
        </motion.div>

        {/* Vertical timeline */}
        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-gold-500/40 via-gold-500/20 to-transparent" />

          <div className="space-y-16 md:space-y-24">
            {steps.map((s, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                data-testid={`step-${i}`}
                className="grid grid-cols-12 gap-6 md:gap-8 items-center"
              >
                {/* Number circle */}
                <div className="col-span-12 md:col-span-1 md:col-start-6 flex items-center justify-start md:justify-center">
                  <div className="relative w-12 h-12 md:w-16 md:h-16 flex items-center justify-center">
                    <div className="absolute inset-0 bg-anthracite-900" />
                    <div className="absolute inset-0 rounded-full border border-gold-500/40" />
                    <span className="relative font-serif italic text-gold-500 text-xl md:text-2xl">{s.num}</span>
                  </div>
                </div>

                {/* Content card - alternating side */}
                {i % 2 === 0 ? (
                  <>
                    <div className="hidden md:block md:col-span-5 md:col-start-1" />
                    <div className="col-span-10 md:col-span-5 md:col-start-7 pl-16 md:pl-4">
                      <div className="text-[10px] uppercase tracking-[0.4em] text-gold-500 mb-3">
                        {s.detail}
                      </div>
                      <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl font-light text-cream leading-tight">
                        {s.title}
                      </h3>
                      <p className="mt-5 text-cream/60 font-light text-base md:text-lg leading-relaxed max-w-md">
                        {s.text}
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-span-10 md:col-span-5 md:col-start-1 md:text-right pl-16 md:pl-0 md:pr-4 order-2 md:order-none">
                      <div className="text-[10px] uppercase tracking-[0.4em] text-gold-500 mb-3 md:text-right">
                        {s.detail}
                      </div>
                      <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl font-light text-cream leading-tight">
                        {s.title}
                      </h3>
                      <p className="mt-5 text-cream/60 font-light text-base md:text-lg leading-relaxed max-w-md md:ml-auto">
                        {s.text}
                      </p>
                    </div>
                    <div className="hidden md:block md:col-span-5 md:col-start-8" />
                  </>
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
